import React, { useState } from 'react';
import FacebookButton from './FacebookButton';
import { signIn } from 'modules/authentication/helpers/nextauth';

type FacebookLoginProps = {
  children: string;
  className?: string;
  callbackUrl?: string;
  onLoginResult: (state: any) => ({ error, success, redirectUrl }: { error?: any; success: boolean; redirectUrl?: string }) => void;
  afterLogin?: () => boolean;
  companyName?: string;
};

const INITIAL_STATE = {
  loading: false,
  error: null,
};


function FacebookLogin({ children, afterLogin, className, callbackUrl, onLoginResult, companyName }: FacebookLoginProps) {
  const [state, setState] = useState(INITIAL_STATE);

  const onLoginClick = async () => {
    setState({ error: null, loading: true });
    try {
      await signIn('facebook', callbackUrl, onLoginResult(setState));
      const hideLoading = afterLogin?.();
      if (hideLoading) {
        setState({ error: null, loading: false });
      }
    } catch (exception) {
      setState({ error: exception, loading: false });
    }
  }

  return (
    <FacebookButton onClick={onLoginClick} className={className} error={state?.error} isLoading={state?.loading}>
      {children}
    </FacebookButton>
  );
}

export default FacebookLogin;
